module.exports = __webpack_public_path__ + "img/in_door.f30731d8.png";